export default "__VITE_ASSET__DyBLGt$K__"